import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { BaseChartDirective } from "ng2-charts";
import { DatePipe } from "@angular/common";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { EmitterService } from "app/Shared/Services/emitter.service";
import { Subscription } from "rxjs";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from "@angular/material/tooltip";
import { ChartConfiguration} from "chart.js";

@Component({
    selector: 'app-cat-finra-rejects-graph',
    imports: [MatTooltipModule, BaseChartDirective, MatProgressSpinnerModule],
    templateUrl: './cat-finra-rejects-graph.component.html',
    styleUrls: ['./cat-finra-rejects-graph.component.scss']
})
export class CatFinraRejectsGraphComponent implements OnInit, OnDestroy {
  isLoadingResults!: boolean;
  windowsize: any;
  currentHover = "Cat";
  windowY: any;
  windowX: any;
  slidecount!: number;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | any;
  JsonData: Object| any;
  Totalcount: number| any;
  TotalcountIntial!:number;
  public dateLabelsArray: any = [];
  private openCount: any[] = [];
  private intrafirmOpenCount: any[] = [];
  private interfirmOpenCount: any[] = [];
  private repairCount: any[] = [];
  public tempdate: any;
  private subscription!: Subscription;
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    legend: {
      position: 'top',
      display: true,
      maxHeight: 10,
      maxWidth: 10,
      align: 'end',
      labels: {
        boxWidth: 10,
        boxHeight: 10
      }
    },
    scales: {
      y: {
        ticks: {
          maxTicksLimit: 10,
          beginAtZero: true,
          stepSize: 1,
          // Create Numberic notation labels
          callback: function (value:any, index:any, values:any) {

            if (value >= 1000 && value < 1000000) {
              value = value / 1000 + ' K';
            }
            if (value >= 1000000) {
              value = value / 1000000 + ' M';
            }
            return value;
          }
        }
      },
      x:{
        grid: {
          display: false
        }
      }
    },
    tooltips: {
      displayColors: true,
      enabled: true,
      backgroundColor: 'Black',
      textColor: 'black',
      opacity: 1,
      callbacks: {
        label: ((tooltipItem:any) => {
          let index = tooltipItem.index;
          let label = tooltipItem.yLabel;
          return label;
        })
      }
    },
    plugins: {
      datalabels: { 
        anchor: 'end',
        align: 'top',
        padding: -6,
        formatter: (value: any) => {
          if (value >= 1000 && value < 1000000) {
            value = Math.floor(value / 1000) + 'K';
          }
          if (value >= 1000000) {
            value = Math.floor(value / 1000000) + 'M';
          }
          return value; 
        },
        color: 'black' 
      },
      legend: {
        display: true,
        position: 'top',
      },
      padding: {
        top: 0
    }
    }
  };

  public barChartLabels: any[] = this.dateLabelsArray;
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
  public barChartColors: any[] = [{ backgroundColor: "#69a4d8" }, { backgroundColor: "#f1995d" }, { backgroundColor: "#D3D3D3" }];
  public barChartData: any[] = [
    {
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      label: 'Repaired',
      backgroundColor: "#69a4d8"
    },
    {
      //Intra-Firm(Ingestion) Array
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      label: 'Ingestion/Intrafirm Open',
      backgroundColor: "#f1995d"
    },
    {
      //Inter-Firm Array
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      label: 'Interfirm Open',
      backgroundColor: "#D3D3D3"
    }
  ];
  LastCATExecutionDate: any;
  private interval:number = 0;
  private leftCounter: number = 0;
  private isRequestCompleted:boolean=true;
  public chartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: this.barChartData
  }
  constructor(
    private UrlsService: UrlsService,
    private datePipe: DatePipe,
    private UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService) {
      this.LastCATExecutionDate = null;
  }

  ngOnInit() {
    this.LastCATExecutionDate = this.UserService.CATLastFinraSubmitDate;
    if(this.LastCATExecutionDate){
    this.getData();
   this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.isLoadingResults = true;
        this.UserService.get_CAT_Last_ReportDate().subscribe((res: any) => {
          let response: any = res;
          let jsondata = response.data[0]
          if(jsondata) {
            this.LastCATExecutionDate = jsondata.FinraSubmitLastExecutionReportDate !=="" ? this.UserService.getFormatedDate(jsondata.FinraSubmitLastExecutionReportDate) : new Date();
            this.getData();
          }
        });
      }
    });
  }
  }

  ngAfterViewInit() {
    this.sortData();
  }

  ngOnChanges(Simple: any) {
    this.chartData= {
      labels: this.barChartLabels,
      datasets: this.barChartData
    }
    this.chart?.chart?.update();
  }

  getData() {
    this.isLoadingResults = true;
    if(this.isRequestCompleted){
    this.isRequestCompleted = false;
    this.SharedHttpClientService.post(
      this.UrlsService.setAPIURl(
        APIURL.CAT_Dash_Finra_Rejects),
      {
        mpid: this.UserService.getActiveMPID(),
        days: this.UserService.getDays() + this.interval
      })
      .subscribe({
        next: (data:any) => {
        this.isRequestCompleted = true;
        this.isLoadingResults = false;
        let RespnseData: any = data;
        this.JsonData = RespnseData.Data;
        if (this.JsonData == null) {
          this.JsonData = [];
          for(let i=0; i<10; i++) {
            this.JsonData[i] = {};
            this.JsonData[i].reportDate = "No-Data";
            this.JsonData[i].repairCount = 0;
            this.JsonData[i].intrafirmOpenCount = 0;
            this.JsonData[i].interfirmOpenCount = 0;
          }
          this.Totalcount = Object.keys(this.JsonData).length;
          this.TotalcountIntial = this.Totalcount;
        }
        else {
          let previousTotal = this.Totalcount;
          this.Totalcount = Object.keys(this.JsonData).length;
          this.TotalcountIntial = this.Totalcount;

          this.slidecount = 0;
          if (this.Totalcount <10) {
            this.windowsize = 0;
            for (let i = 0, t = 0; i < this.Totalcount; i++ , t++) {
              this.dateLabelsArray.push(this.datePipe.transform(this.JsonData[i].reportDate, 'dd-MMM'));
              this.repairCount[t] = (this.JsonData[i].repairCount)
              this.intrafirmOpenCount[t] = (this.JsonData[i].intrafirmOpenCount);
              this.interfirmOpenCount[t] = (this.JsonData[i].interfirmOpenCount);
            }
          } else {
            this.windowsize = 5;
            if (this.leftCounter < 6) {
              this.windowY = this.Totalcount + this.slidecount;
              this.windowX = (this.windowY - this.windowsize);

            } else {
              this.windowX = this.windowX + (Object.keys(this.JsonData).length - previousTotal);
              this.windowY = this.windowX + 5;
            }
            this.sortData();
          }
          this.barChartData = [
            {
              //Repair Array
              data: [this.repairCount[0], this.repairCount[1], this.repairCount[2], this.repairCount[3], this.repairCount[4], this.repairCount[5], this.repairCount[6], this.repairCount[7], this.repairCount[8], this.repairCount[9]],
              label: 'Repaired',
              backgroundColor: "#69a4d8"
            },
            {
              //IntraFirm-Open(Ingestion) Array
              data: [this.intrafirmOpenCount[0], this.intrafirmOpenCount[1], this.intrafirmOpenCount[2], this.intrafirmOpenCount[3], this.intrafirmOpenCount[4], this.intrafirmOpenCount[5], this.intrafirmOpenCount[6], this.intrafirmOpenCount[7], this.intrafirmOpenCount[8], this.intrafirmOpenCount[9]],
              label: 'Ingestion/Intrafirm Open',
              backgroundColor: "#f1995d"
            },
            {
              //InterFirm-Open Array
              data: [this.interfirmOpenCount[0], this.interfirmOpenCount[1], this.interfirmOpenCount[2], this.interfirmOpenCount[3], this.interfirmOpenCount[4], this.interfirmOpenCount[5], this.interfirmOpenCount[6], this.interfirmOpenCount[7], this.interfirmOpenCount[8], this.interfirmOpenCount[9]],
              label: 'Interfirm Open',
              backgroundColor: "#D3D3D3"
            }
          ];
          this.chartData= {
            labels: this.barChartLabels,
            datasets: this.barChartData
          }
        }
        },
        error: (e) => {
            console.error(e);
            this.isLoadingResults = false;
        }
      });
    }
  }

  clickLeft() {
    this.slidecount = -1;
    this.leftCounter++;
    if ((this.leftCounter%15!=0) && this.windowX!=10) {
      this.windowY = this.windowY + this.slidecount;
      this.windowX = (this.windowY - this.windowsize);
      this.sortData();
    }
  }

  clickRight() {
    this.slidecount = 1;
    if (this.windowY <= this.TotalcountIntial && this.windowsize >= 5) {
      this.windowY = this.windowY + this.slidecount;
      this.windowX = (this.windowY - this.windowsize);
      this.Totalcount += 1;
      this.sortData();
    }
  }

  sortData() {
    if ((this.windowY < this.Totalcount || this.leftCounter == 0) && this.windowY > 0) {
      if((this.leftCounter != 0 && this.leftCounter%15 == 0) || this.windowX==10){
        this.interval += 30;
        this.leftCounter++;
        this.getData();
      }
      this.dateLabelsArray.splice(0, this.dateLabelsArray.length);
      this.intrafirmOpenCount.splice(0, this.intrafirmOpenCount.length);
      this.interfirmOpenCount.splice(0, this.interfirmOpenCount.length);
      this.repairCount.splice(0, this.repairCount.length);

      for (let i = this.windowX, t = 0; i < this.windowY; i++ , t++) {  
        if(this.JsonData[i] != undefined){             
        this.dateLabelsArray.push(this.datePipe.transform(this.JsonData[i].reportDate, 'dd-MMM'));
        this.repairCount[t] = (this.JsonData[i].repairCount)
        this.intrafirmOpenCount[t] = (this.JsonData[i].intrafirmOpenCount);
        this.interfirmOpenCount[t] = (this.JsonData[i].interfirmOpenCount);
      } 
      }
    }  
    this.reloadData();  
  }

  reloadData() {
    this.barChartData = [
      {
        //Repair Array
        data: [this.repairCount[0], this.repairCount[1], this.repairCount[2], this.repairCount[3], this.repairCount[4], this.repairCount[5], this.repairCount[6], this.repairCount[7], this.repairCount[8], this.repairCount[9]],
        label: 'Repaired',
        backgroundColor: "#69a4d8"
      },
      {
        //IntraFirm-Open(Ingestion) Array
        data: [this.intrafirmOpenCount[0], this.intrafirmOpenCount[1], this.intrafirmOpenCount[2], this.intrafirmOpenCount[3], this.intrafirmOpenCount[4], this.intrafirmOpenCount[5], this.intrafirmOpenCount[6], this.intrafirmOpenCount[7], this.intrafirmOpenCount[8], this.intrafirmOpenCount[9]],
        label: 'Ingestion/Intrafirm Open',
        backgroundColor: "#f1995d"
      },
      {
        //InterFirm-Open Array
        data: [this.interfirmOpenCount[0], this.interfirmOpenCount[1], this.interfirmOpenCount[2], this.interfirmOpenCount[3], this.interfirmOpenCount[4], this.interfirmOpenCount[5], this.interfirmOpenCount[6], this.interfirmOpenCount[7], this.interfirmOpenCount[8], this.interfirmOpenCount[9]],
        label: 'Interfirm Open',
        backgroundColor: "#D3D3D3"
      }
    ];
    this.chartData= {
      labels: this.barChartLabels,
      datasets: this.barChartData
    }
    this.chart?.chart?.update();
  }

  // events
  public chartClicked(e: any): void {
    let date: any = "NULL"
    let ChartElement;
    if (e.active.length > 0) {
      ChartElement = e.active[0]
      if (ChartElement) {
        date = this.dateLabelsArray[ChartElement._index];
        e.active[0]._view.backgroundColor = "green";
        e.active[0]._model.backgroundColor = "green";
        e.active[1]._view.backgroundColor = "green";
        e.active[1]._model.backgroundColor = "green";
        e.active[1]._chart.ctx.backgroundColor = "green";

        const chart0 = e.active[0]._chart;
        const chart1 = e.active[1]._chart;
        const activePoints = chart0.getElementAtEvent(e.event);
        if (activePoints.length > 0) {
          // get the internal index of slice in pie chart
          const clickedElementIndex = activePoints[0]._index;

          const label = chart0.data.labels[clickedElementIndex];
          // get value by index
          const value = chart0.data.datasets[0].data[clickedElementIndex];
        }

      }
      this.chartData= {
        labels: this.barChartLabels,
        datasets: this.barChartData
      }
      this.chart?.chart?.update();
    }

  }

  public chartHovered(e: any): void { }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
